export default __webpack_public_path__ + "assets/models/db2c6f3fb8a076ad4247f844bb5ae412.glb";